function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.0762,1.9189 L1.7222,5.9549 C1.8472,6.2589 2.0782,6.5019 2.3692,6.6329 L6.9712,8.7049 C7.2192,8.8159 7.2192,9.1839 6.9712,9.2949 L2.3692,11.3669 C2.0782,11.4979 1.8472,11.7409 1.7222,12.0449 L0.0762,16.0809 C-0.3148,17.2769 0.8692,18.3799 2.0032,17.8739 L19.2512,10.1819 C20.2502,9.7359 20.2502,8.2639 19.2512,7.8179 L2.0032,0.1259 C0.8692,-0.3801 -0.3148,0.7229 0.0762,1.9189",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/send.0cc94ae5.svg";
export { SvgComponent as ReactComponent };